import { commonStyles, containerStyles, sectionStyles, tileStyles, } from "./shared.styles";
export const contextRationaleSectionStyles = {
    // Re-export shared styles for easy access
    sectionHeader: sectionStyles.header,
    sectionHeaderComplete: sectionStyles.headerComplete,
    unifiedTile: tileStyles.unifiedTile,
    technicalDepthTileContent: tileStyles.selectionTileContent,
    technicalDepthIconContainer: tileStyles.selectionTileIconContainer,
    technicalDepthIcon: tileStyles.selectionTileIcon,
    escalationReasonsContainer: containerStyles.escalationReasonsContainer,
    // Component-specific styles (using common styles)
    sectionContainer: commonStyles.sectionContainer,
    textField: commonStyles.textField,
    autoTypingField: commonStyles.autoTypingField,
    sectionGroup: commonStyles.sectionGroup,
    optionalSection: commonStyles.optionalSection,
    optionalSubsectionHeader: commonStyles.optionalSubsectionHeader,
    fieldDescription: commonStyles.fieldDescription,
};
